// extracted by mini-css-extract-plugin
export default {"menuContainer":"menu_menuContainer__FdmxH","titlePage":"menu_titlePage__5asYc","logoutIcon":"menu_logoutIcon__Y3Xhe"};